import './app.css'
import Accordion from "./components/Accordion"
import {useEffect , useState , useRef} from "react"
import {DeviceProvider} from "../Dashboard/DeviceContext"
//import {io} from "socket.io-client"

import {useNavigate} from "react-router-dom";
import Switch from "./components/Switch"
import SendData from "./SendData"

import {BrowserRouter as Router , Routes , Route , Link } from 'react-router-dom';


import Home from "./Home";
import GetPhone from "./GetPhone";
import GetCode from "./GetCode";
import MainApp from "./MainApp";
import MainSetting from "./MainSetting";
import SystemSetting from "./SystemSetting";
import NameSetting from "./NameSetting";
import ConfigSetting from "./ConfigSetting";
import WindowSetting from "./WindowSetting";
import MandatorySetting from "./MandatorySetting";
import ErrorSetting from "./ErrorSetting";
import PhoneSetting from "./PhoneSetting";
import TimeSetting from "./TimeSetting";
import MenuTimeSetting from "./MenuTimeSetting";
import PhoneNumber from "./PhoneNumber";
import VerifyCode from "./VerifyCode";
import About from "./About";
import Contact from "./Contact";
import Dashboard from "../Dashboard/Dashboard";
import Games from "./Games";
import Charge from "./Charge";
import PaymentResult from "./PaymentResult";

//const SERVER_URL=/*'10.188.147.153:5002'*/   'http://mega-games.ir:5002';



function MainRoute () {
  const [status,setStatus] = useState ("disconnected");
  const [data,setData] = useState (null);
  const navigate = useNavigate ();

  const token=localStorage.getItem ('token');
  const phone=localStorage.getItem ('phone');
  const boards=JSON.parse(localStorage.getItem ('boards'));
  const select_board=localStorage.getItem ('select_board');
  const socket =  useRef (null);

  useEffect (()=>{
/*
    socket.current=io(SERVER_URL,{transports:['websocket'],reconnectionAttempts:5,timeout:5000});
    socket.current.on ('connect',()=>{
      setStatus ("connected")
//      socket.current.emit ('myPhone',{"phone":'09133337058'});
    });
    socket.current.on ('disconnect',()=>setStatus ("disconnected"));
    socket.current.on ('message',(data)=>{
  //    setData (data);
    });
  */
/*    if (id!=null && phone!=null && boards!=null && select_board!=null)
      navigate ('/MainApp')
    else
      navigate ('/GetPhone');
      */
    //  navigate ('/Home');
  //    navigate ('/MainApp');
  },[]);


  return(
    <div>
    <DeviceProvider>
      <Routes>
        <Route path="/" element={<Home socket={socket.current}/>} />
        <Route path="/GetPhone" element={<GetPhone socket={socket.current}/>} />
        <Route path="/GetCode" element={<GetCode socket={socket.current}/>} />
        <Route path="/MainApp" element={<MainApp socket={socket.current}/>} />
        <Route path="/MainSetting" element={<MainSetting socket={socket.current}/>} />
        <Route path="/SystemSetting" element={<SystemSetting socket={socket.current}/>} />
        <Route path="/NameSetting" element={<NameSetting socket={socket.current}/>} />
        <Route path="/ConfigSetting" element={<ConfigSetting socket={socket.current}/>} />
        <Route path="/PhoneSetting" element={<PhoneSetting socket={socket.current}/>} />
        <Route path="/ErrorSetting" element={<ErrorSetting socket={socket.current}/>} />
        <Route path="/WindowSetting" element={<WindowSetting socket={socket.current}/>} />
        <Route path="/MandatorySetting" element={<MandatorySetting socket={socket.current}/>} />
        <Route path="/TimeSetting" element={<TimeSetting socket={socket.current}/>} />
        <Route path="/MenuTimeSetting" element={<MenuTimeSetting socket={socket.current}/>} />
        <Route path="/PhoneNumber" element={<PhoneNumber/>} />
        <Route path="/VerifyCode" element={<VerifyCode/>} />
        <Route path="/About" element={<About/>} />
        <Route path="/Contact" element={<Contact/>} />
        <Route path="/Dashboard" element={<Dashboard/>} />
        <Route path="/Games" element={<Games/>} />
        <Route path="/Charge" element={<Charge/>} />
        <Route path="/PaymentResult" element={<PaymentResult/>} />
      </Routes>
      </DeviceProvider>
    </div>
  );

}
export default MainRoute;
